import { CalendarChartColorPalette } from './calendar-chart-input.interface';

export const calendarChartDefaultColorPalette: CalendarChartColorPalette = {
  filled: '#2C343C',
  unfilled: '#E8EEF4',
  empty: '#E8EEF4',
};
